import { Card, Button, Tag, Badge, Modal, Divider } from "antd"
import { useState } from "react"
import styles from "./HistoryRecomendationCard.module.css"
import CircularProgress from "../CircularProgress"
import { useSelector } from "react-redux"
import { selectCurrentUser } from "../../../../../redux/user/user.selectors"
import axios from "axios"

const levelStyles = {
  "Ready to Lead": {
    bg: "#f6ffed",
    color: "#52c41a",
  },
  "Emerging Talent": {
    bg: "#fffbe6",
    color: "#faad14",
  },
  "Need Boost": {
    bg: "#fff1f0",
    color: "#ff4d4f",
  },
}

const HistoryRecommendationCard = ({
  variant = "CAREER_DIAGNOSIS", // career | food
  title,
  score,
  level,
  status,
  description,
  recommendation,
  lastUpdate,
  buttonText = "Detail",
  foodPathResult,
  userStatus,
  foodIndustryExperience,
  field,
  id,
  getListResultAnswerUser,
}) => {
  const [open, setOpen] = useState(false)
  const [isOpenModalDestroy, setOpenModalDestroy] = useState(false)
  const isCareer = variant === "CAREER_DIAGNOSIS"
  const isFood = variant === "FOOD_PATH"

  const currentUser = useSelector(selectCurrentUser)

  const statusColor =
    status === "Done" ? "green" : status === "In Progress" ? "gold" : "default"

  const levelStyle = levelStyles[level]

  const handleDestroy = () => {
    axios({
      method: "delete",
      url:
        variant === "CAREER_DIAGNOSIS"
          ? `/career-diagnosis/destroy/${id}`
          : `/career-diagnosis/food-path/destroy/${id}`,
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        console.log("res", response)
        handleModalCloseDestroy()
        getListResultAnswerUser()
      })
      .catch((err) => {
        console.error("Error :", err)
      })
  }

  const handleContinueUrl = (id) => {
    const payload = JSON.stringify({
      isContinue: "1",
      productType: variant,
      id,
    })

    axios({
      method: "post",
      url: `/career-diagnosis/portal`,
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    })
      .then((response) => {
        const data = response.data.data
        console.log("portal", response)
        if (data && data.portalToken) {
          const url = `https://career-diagnosis.mindoeducation.co.id/portal?token=${data.portalToken}`
          window.location.href = url
        }
      })
      .catch((err) => {
        console.error("Error :", err)
      })
  }

  const handleModalCloseDestroy = () => {
    setOpenModalDestroy(false)
  }

  return (
    <>
      <Card className={styles.card}>
        <h3 className={styles.title}>{title}</h3>
        <Badge color={statusColor} text={status} />
        <hr className={styles.line} />

        <div className={styles.content}>
          <div className={styles.scoreSection}>
            {score !== undefined && score !== null && (
              <CircularProgress value={score} />
            )}

            {isCareer && level && (
              <div className={styles.wrapLevel}>
                <div className={styles.level}>
                  <p>Level: </p>
                  <Tag
                    style={{
                      backgroundColor: levelStyle?.bg,
                      color: levelStyle?.color,
                      border: "none",
                    }}>
                    {level}
                  </Tag>
                </div>
                <div className={styles.level}>
                  <p>Last Update: </p>
                  <p>{lastUpdate}</p>
                </div>
              </div>
            )}
          </div>
          {isFood && (
            <>
              <div className={styles.level}>
                <p>Rekomendasi Bidang </p>
                <p>{foodPathResult ?? "-"}</p>
              </div>
              <div className={styles.level}>
                <p>Last Update: </p>
                <p>{lastUpdate}</p>
              </div>
            </>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
            className={styles.infoSection}>
            <Button
              onClick={() => setOpenModalDestroy(true)}
              block
              type="primary"
              style={{
                width: "100%",
                borderColor: "#BB2124",
                backgroundColor: "#BB2124",
                color: "#fff",
              }}>
              Hapus
            </Button>
            <Button
              type="primary"
              block
              onClick={() => {
                if (status === "INPROGRESS") {
                  handleContinueUrl(id)
                } else {
                  setOpen(true)
                }
              }}>
              {buttonText}
            </Button>
          </div>
        </div>
      </Card>

      {/* ===== MODAL ===== */}
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        centered
        width={720}
        className={styles.modal}>
        <h2 className={styles.modalTitle}>{title}</h2>
        <Badge color={statusColor} text={status} />

        {score && (
          <>
            <Divider />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}>
                {userStatus && (
                  <div>
                    <h4>Status Saat ini</h4>
                    <p className={styles.text}>{userStatus}</p>
                  </div>
                )}

                {foodIndustryExperience && (
                  <div>
                    <h4>Pengalaman di industri pangan</h4>
                    <p className={styles.text}>{foodIndustryExperience}</p>
                  </div>
                )}

                {field && (
                  <div>
                    <h4>Bidang yang diminati</h4>
                    <p className={styles.text}>{field}</p>
                  </div>
                )}
              </div>

              <div className={styles.modalScore}>
                {score && <CircularProgress value={score ?? 0} />}

                {isCareer && level && (
                  <Tag
                    style={{
                      backgroundColor: levelStyle?.bg,
                      color: levelStyle?.color,
                      border: "none",
                    }}>
                    Level {level}
                  </Tag>
                )}
              </div>
            </div>
          </>
        )}

        {description && (
          <>
            <Divider />

            <section>
              <h4>{isCareer ? "Interpretasi" : "Deskripsi"}</h4>
              <p className={styles.text}>{description || "-"}</p>
            </section>
          </>
        )}

        {recommendation && (
          <>
            <Divider />
            <section>
              <h4>Rekomendasi Product</h4>
              <div className={styles.recommendation}>{recommendation}</div>
            </section>
          </>
        )}

        {foodPathResult && (
          <>
            <Divider />
            <section>
              <h4>Rekomendasi Bidang</h4>
              <div className={styles.recommendation}>{foodPathResult}</div>
            </section>
          </>
        )}
      </Modal>
      <Modal
        open={isOpenModalDestroy}
        onCancel={handleModalCloseDestroy}
        footer={null}
        centered>
        <div className={styles.modalContent}>
          <h3>{variant === "FOOD_PATH" ? "Food Path" : "Career Diagnosis"}</h3>

          <p>
            Apakah ingin menghapus hasil rekomendasi pada tanggal {lastUpdate}?
          </p>

          <div className={styles.modalActions}>
            <Button
              type="primary"
              className={styles.btn}
              onClick={() => handleModalCloseDestroy()}>
              Batal
            </Button>
            <Button
              onClick={() => {
                handleDestroy()
              }}
              type="primary"
              style={{                
                borderColor: "#BB2124",
                backgroundColor: "#BB2124",
                color: "#fff",
              }}>
              Hapus
            </Button>

          </div>
        </div>
      </Modal>
    </>
  )
}

export default HistoryRecommendationCard
